"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;exports.__esModule = true;exports.ThemeContext = void 0;var _react = _interopRequireDefault(require("react"));

var _ThemeFactory = require("./ThemeFactory");

var ThemeContext = exports.ThemeContext = /*#__PURE__*/_react.default.createContext(_ThemeFactory.ThemeFactory.defaultTheme);

ThemeContext.displayName = 'ThemeContext';
ThemeContext.__KONTUR_REACT_UI__ = 'ThemeContext';